import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React from 'react';
import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { buildMarketDataKey } from '../../../../../../../stores/websocketStore/utils/marketDataRouting';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';

export const Last = observer(({ alert }) => {
  const { priceDataStore } = useWebsocketStore();
  const symbol = alert.symbol;
  const dataSource = alert.dataSource;
  const hash = buildMarketDataKey({
    symbol,
    dataSource,
    brokerage: alert.brokerage,
  });
  const last = ApplyRounding(priceDataStore.lastTrade[hash]?.last, 2);
  return (
    <td style={{ minWidth: '60px' }}>
      <Body3 color={colors.lightGrey} fontWeight={500}>
        {isNaN(last) ? 'N/A' : ` ${last}`}
      </Body3>
    </td>
  );
});

Last.propTypes = {
  alert: PropTypes.shape({
    dataSource: PropTypes.any,
    symbol: PropTypes.any,
  }),
};
